// extracted by mini-css-extract-plugin
module.exports = {"loading":"style_loading__Ugw_M","loading-lottie":"style_loading-lottie___NMK1"};